<template>
  <div
    v-if="isOnboardingRedesign"
    class="symptoms-icon tw-flex tw-items-center tw-gap-2 tw-px-2"
  >
    <img
      v-if="isSelected"
      :src="selectedIcon"
      :alt="symptom.name"
      class="symptoms-icon__img"
    >
    <img
      v-else
      :src="srcV2"
      :alt="symptom.name"
      class="symptoms-icon__img"
    >

    <span class="symptoms-icon__name tw-text-left">
      {{ symptom.name }}
    </span>
  </div>
  <div
    v-else
    class="symptoms-icon"
  >
    <img
      :src="src"
      :alt="symptom.name"
      class="symptoms-icon__img"
    >

    <span class="symptoms-icon__name">
      {{ symptom.name }}
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import IconAnxiety from '@/assets/images/symptoms/anxiety.svg';
import IconBrain from '@/assets/images/symptoms/brain.svg';
import IconEnergy from '@/assets/images/symptoms/energy.svg';
import IconFatigue from '@/assets/images/symptoms/fatigue.svg';
import IconHair from '@/assets/images/symptoms/hair.svg';
import IconHotFlashes from '@/assets/images/symptoms/hot-flashes.svg';
import IconLosingMuscle from '@/assets/images/symptoms/losing-muscle.svg';
import IconMood from '@/assets/images/symptoms/mood.svg';
import IconNightSweats from '@/assets/images/symptoms/night-sweats.svg';
import IconSexAndLibido from '@/assets/images/symptoms/sex-and-libido.svg';
import IconSkin from '@/assets/images/symptoms/skin.svg';
import IconSleep from '@/assets/images/symptoms/sleep.svg';
import IconUrinary from '@/assets/images/symptoms/urinary.svg';
import IconVaginalDryness from '@/assets/images/symptoms/vaginal-dryness.svg';
import IconWeightGain from '@/assets/images/symptoms/weight-gain.svg';

// v2 icons - onboarding redesign
import IconAnxietyV2 from '@/assets/images/symptoms/v2/anxiety.svg';
import IconBrainV2 from '@/assets/images/symptoms/v2/brain.svg';
import IconEnergyV2 from '@/assets/images/symptoms/v2/energy.svg';
import IconFatigueV2 from '@/assets/images/symptoms/v2/fatigue.svg';
import IconHairV2 from '@/assets/images/symptoms/v2/hair.svg';
import IconHotFlashesV2 from '@/assets/images/symptoms/v2/hot-flashes.svg';
import IconLosingMuscleV2 from '@/assets/images/symptoms/v2/losing-muscle.svg';
import IconMoodV2 from '@/assets/images/symptoms/v2/mood.svg';
import IconNightSweatsV2 from '@/assets/images/symptoms/v2/night-sweats.svg';
import IconSexAndLibidoV2 from '@/assets/images/symptoms/v2/sex-and-libido.svg';
import IconSkinV2 from '@/assets/images/symptoms/v2/skin.svg';
import IconSleepV2 from '@/assets/images/symptoms/v2/sleep.svg';
import IconUrinaryV2 from '@/assets/images/symptoms/v2/urinary.svg';
import IconVaginalDrynessV2 from '@/assets/images/symptoms/v2/vaginal-dryness.svg';
import IconWeightGainV2 from '@/assets/images/symptoms/v2/weight-gain.svg';

import IconJointPainV2 from '@/assets/images/symptoms/v2/jointpain.svg';
import IconSelected from '@/assets/images/symptoms/v2/selected.svg';

export default {
  props: {
    symptom: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    selectedIcon() {
      return this.isSelected ? IconSelected : '';
    },
    src() {
      switch (this.symptom.id) {
        case 'anxiety':
          return IconAnxiety;
        case 'brain':
          return IconBrain;
        case 'energy':
          return IconEnergy;
        case 'fatigue':
          return IconFatigue;
        case 'hair':
          return IconHair;
        case 'hotflashes':
          return IconHotFlashes;
        case 'losingmuscle':
          return IconLosingMuscle;
        case 'mood':
          return IconMood;
        case 'nightsweats':
          return IconNightSweats;
        case 'sexandlibido':
          return IconSexAndLibido;
        case 'skin':
          return IconSkin;
        case 'sleep':
          return IconSleep;
        case 'urinary':
          return IconUrinary;
        case 'vaginaldryness':
          return IconVaginalDryness;
        case 'weightgain':
          return IconWeightGain;
        case 'jointpain':
          return IconJointPainV2;
        default:
          return '';
      }
    },
    srcV2() {
      switch (this.symptom.id) {
        case 'anxiety':
          return IconAnxietyV2;
        case 'brain':
          return IconBrainV2;
        case 'energy':
          return IconEnergyV2;
        case 'fatigue':
          return IconFatigueV2;
        case 'hair':
          return IconHairV2;
        case 'hotflashes':
          return IconHotFlashesV2;
        case 'losingmuscle':
          return IconLosingMuscleV2;
        case 'mood':
          return IconMoodV2;
        case 'nightsweats':
          return IconNightSweatsV2;
        case 'sexandlibido':
          return IconSexAndLibidoV2;
        case 'skin':
          return IconSkinV2;
        case 'sleep':
          return IconSleepV2;
        case 'urinary':
          return IconUrinaryV2;
        case 'vaginaldryness':
          return IconVaginalDrynessV2;
        case 'weightgain':
          return IconWeightGainV2;
        case 'jointpain':
          return IconJointPainV2;
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
html:not(.redesign) {
  .symptoms-icon {
    position: relative;
    width: 100%;
    height: 100%;

    &__img {
      position: absolute;
      top: 30%;
      left: 50%;
      transform: translate(-50%, -30%);
      width: 35px;
      height: 35px;
    }

    &__name {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 7px;
      text-align: center;
      font-size: 12px;
      color: #19191c;
    }
  }
}

.redesign {
  .symptoms-icon {
    position: relative;
    width: 100%;
    height: 100%;
  
    &__img {
      width: 20px;
      height: 20px;
    }
  
    &__name {
      text-align: center;
      color: #19191c;
    }
  }
}
</style>
